import { useMutation } from '@tanstack/react-query';

import { useNotification } from '@sine/sine-ui-components';

import parseServerError from '../../helpers/parseServerError';
import { MutationKeys } from '../../query.client';
import companyService from '../../services/company/company.service';

/**
 * Uses useMutation instead of useQuery because AsyncSingleSelect requires a searchFunction
 * that accepts a searchTerm parameter: (searchTerm: string) => Promise<ISelectOption[]>.
 * useQuery's refetch() doesn't accept parameters, but useMutation's mutateAsync() does.
 */
export function useCompaniesSearchScopedMutation(teamId?: string) {
  const { addNotification } = useNotification();

  const { mutateAsync: loadVerifiedCompaniesOptions } = useMutation({
    mutationKey: [MutationKeys.COMPANIES_VERIFIED_OPTIONS],
    mutationFn: async (searchTerm: string) => {
      const data = await companyService.searchScoped(searchTerm, teamId);

      return data.verifiedCompanies.map((company) => ({
        label: company.name,
        value: company.id,
        source: 'verified',
      }));
    },
    onError: (error: any) => {
      addNotification({
        message: parseServerError(error),
        variant: 'danger',
      });
    },
  });

  return {
    loadVerifiedCompaniesOptions,
  };
}
